import React from 'react';
import { useIsIssueViewModalOpen } from '@jira/issue__issue-view-modal-state/src/useIsIssueViewModalOpen.tsx';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { useRovoExperienceAPIStore } from '@atlassian/rovo-experience-api/rovo-experience-api-store';
import { AiRovoButtonWrapperRefresh } from './AiRovoButtonWrapperRefresh.tsx';
import { useIsGlobalRovoButtonAvailableForRoute } from './useIsGlobalRovoButtonAvailableForRoute.tsx';
import { useShouldShowRovoButton } from './useShouldShowRovoButton.tsx';

export const GlobalAiRovoButton = (): React.JSX.Element | null => {
	const isRovoAvailableForRoute = useIsGlobalRovoButtonAvailableForRoute();
	const showRovoButton = useShouldShowRovoButton();
	const [isIssueViewModalOpen] = useIsIssueViewModalOpen();
	const { mode: rovoMode } = useRovoExperienceAPIStore();
	const shouldShowPlaceholder = isIssueViewModalOpen && rovoMode !== 'sidebar';

	if (!isRovoAvailableForRoute || !showRovoButton) {
		return null;
	}

	return (
		<>
			{shouldShowPlaceholder ? (
				<Box aria-hidden xcss={styles.placeholder} />
			) : (
				<AiRovoButtonWrapperRefresh />
			)}
		</>
	);
};

const styles = cssMap({
	placeholder: {
		width: '48px',
		height: '48px',
	},
});
